import DevExpress from 'devextreme/bundles/dx.all';

/** default settings for DX Lookup */
export const dxSelectBoxDefaults: DevExpress.ui.dxSelectBoxOptions<any> = {
	searchEnabled: true,
	onFocusIn: $event => {
		(<HTMLInputElement>(<any>$event.component.instance().field())).select();
	},
};
